const STEPS = [
  {
    n: "01",
    title: "Guide",
    body: "Employees follow guided digital workflows instead of paper checklists.",
  },
  {
    n: "02",
    title: "Capture & monitor",
    body: "Operational data is recorded with timestamps, photos and digital verification. Managers gain real-time visibility across every outlet.",
  },
  {
    n: "03",
    title: "Improve",
    body: "Identify operational gaps, reduce compliance risks and continuously improve performance.",
  },
];

export function Workflow() {
  return (
    <section id="workflow" className="bg-white py-24 md:py-32" data-testid="workflow-section">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center">
          <p
            className="text-[11px] md:text-[13px] uppercase tracking-[0.45em] text-brand-navy/50 mb-4"
            data-testid="workflow-eyebrow"
          >
            How it works
          </p>
          <h2
            className="font-poppins font-semibold text-brand-navy text-3xl md:text-5xl tracking-tight leading-tight"
            data-testid="workflow-heading"
          >
            Three steps. Compliance runs itself.
          </h2>
        </div>

        <ol className="mt-16 md:mt-20 grid md:grid-cols-3 gap-10 md:gap-14">
          {STEPS.map((s) => (
            <li key={s.n} className="text-center" data-testid={`workflow-step-${s.n}`}>
              <div className="font-poppins font-light text-7xl md:text-8xl text-brand-orange/90 leading-none tabular-nums">
                {s.n}
              </div>
              <h3 className="mt-6 font-poppins text-xl md:text-2xl font-semibold text-brand-navy">
                {s.title}
              </h3>
              <p className="mt-3 text-brand-slate/80 leading-relaxed max-w-xs mx-auto">
                {s.body}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
